import(/* webpackMode: "eager" */ "/home/runner/work/thriwe-marketplace-ui/thriwe-marketplace-ui/app/(pages)/(static-pages)/faq/page.tsx");
